import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'
import { ProvideExtraPersonalIdMessage } from '../ProvideExtraPersonalIdMessage'

export class ReverificationMessage extends React.Component<{
  hasVerificationFailed: boolean
}> {
  private reverificationFailureRef: HTMLElement | null = null

  public componentDidMount() {
    // on error scrolls to the error
    if (this.reverificationFailureRef && this.reverificationFailureRef.scrollIntoView) {
      this.reverificationFailureRef.scrollIntoView()
    }
  }

  public render() {
    const { hasVerificationFailed } = this.props
    const isError = hasVerificationFailed
    const title = isError ? 'Re-verification failed' : 'Provide extra personal ID'

    return (
      <div
        ref={node => {
          this.reverificationFailureRef = node
        }}
      >
        <NoticeBox title={title} noticeBoxType={isError ? 'Error' : 'Info'} hasBorder>
          <ProvideExtraPersonalIdMessage />
        </NoticeBox>
      </div>
    )
  }
}
